import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	dayPart: null,
	error: "",
	loading: false,
};

export const createDayPartSchedule = createAsyncThunk(
	"dayPartSchedule/createDayPartSchedule",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `dayPartSchedule/createDayPartSchedule`,
				data: {
					...values,
				},
			});
			toast.success("Day Part Schedule Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Day Part Schedule try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const getDayPartSchedules = createAsyncThunk(
	"dayPartSchedule/getDayPartSchedules",
	async () => {
		try {
			const { data } = await axios.get(`dayPartSchedule/getDayPartSchedules`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getSingledayPartSchedule = createAsyncThunk(
	"dayPartSchedule/getSingledayPartSchedule",
	async (id) => {
		try {
			const data = await axios.get(`dayPartSchedule/${id}`);
            console.log('Fetched single day part schedule:', data);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateSingledayPartSchedule = createAsyncThunk(
	"dayPartSchedule/updateSingledayPartSchedule",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `dayPartSchedule/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Day Part Schedule Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Day Part Schedule try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const deleteSingledayPartSchedule = createAsyncThunk(
	"dayPartSchedule/deleteSingledayPartSchedule ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `dayPartSchedule/${id}`,
			});

			toast.success("Day Part Schedule Deleted");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Day Part Schedule try again");
			console.log(error.message);
		}
	}
);




const dayPartSlice = createSlice({
	name: "dayPart",
	initialState,
	reducers: {
		clearDayPartSchedule: (state) => {
			state.dayPart = null;
		},
	},
	extraReducers: (builder) => {
		
		// 1) ====== builders for getDayPartSchedules ======

		builder.addCase(getDayPartSchedules.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getDayPartSchedules.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getDayPartSchedules.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		
		// 2) ====== builders for createDayPartSchedule  ======

		builder.addCase(createDayPartSchedule.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(createDayPartSchedule.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(createDayPartSchedule.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
		
        // 3) ====== builders for getSingledayPartSchedule ======

		builder.addCase(getSingledayPartSchedule.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getSingledayPartSchedule.fulfilled, (state, action) => {
			state.loading = false;
  console.log('Fetched dayPart:', action.payload); // Log to verify the response structure
  state.dayPart = action.payload.data;
		});

		builder.addCase(getSingledayPartSchedule.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

        // 4) ====== builders for updateSingledayPartSchedule ======

		builder.addCase(updateSingledayPartSchedule.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateSingledayPartSchedule.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateSingledayPartSchedule.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

        // 5) ====== builders for deleteSingledayPartSchedule  ======

		builder.addCase(deleteSingledayPartSchedule.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteSingledayPartSchedule.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteSingledayPartSchedule.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default dayPartSlice.reducer;
export const { clearDayPartSchedule } = dayPartSlice.actions;
